// import needed stuff
import {i18n} from '@moxiltd/moxijs/src/i18n';
import {api} from '@moxiltd/moxijs/src/api/api';
import {ApiClientFactory} from '@moxiltd/moxijs/src/api/apiclientfactory';
import {FrontendForm} from '@moxiltd/moxijs/src/form/frontendform';
import {TextWidget} from '@moxiltd/moxijs/src/widgets/text';
import {DropdownWidget} from '@moxiltd/moxijs/src/widgets/dropdown';
import {DateWidget} from '@moxiltd/moxijs/src/widgets/date';
import {HiddenWidget} from '@moxiltd/moxijs/src/widgets/hidden';
import {ReCaptcha2Widget} from '@moxiltd/moxijs/src/widgets/recaptcha';
import {initForm} from "./form";
import * as functions from './functions';
import bulmaAccordion from 'bulma-accordion/dist/js/bulma-accordion.min.js';
import Swipe from 'swipejs';
import {SwipeSlider} from './swipe-slider';
import * as filter from './filter';
import {SwiperSlider} from './swiper';
import * as lightbox from './lightbox';
import Swiper from 'swiper/bundle';
import './navigation';
import './cookies';

import Bulma, {Notification} from '@vizuaalog/bulmajs/src/plugins/notification';
import browserUpdate from 'browser-update';

// make moxi functions available from outside, e.g. templates
window.moxi = {
    api,
    ApiClientFactory,
    i18n,
    widgets: {
        TextWidget,
        DropdownWidget,
        DateWidget,
        HiddenWidget,
        ReCaptcha2Widget
    },
    FrontendForm,
    initForm,
    functions,
    bulmaAccordion,
    filter,
    lightbox,
};

// bulma-js
window.Bulma = Bulma;
window.Swipe = Swipe;
window.Swiper = Swiper;

// browser update
window.browserUpdate = browserUpdate;

window.moxi.bulmaAccordion.attach();

// SWIPE JS Homepage Header Slider ------------
SwipeSlider();
// SWIPE JS END------------

SwiperSlider();

// trigger moxiJsLoaded event
document.dispatchEvent(new Event('moxiJsLoaded'));
